import type { FC, ReactNode } from "react";
import { cn } from "@/lib/cn";

type BorderBeamProps = {
  /** `rest` is subtle and hides while focus is inside, `off` hides it. */
  state?: "rest" | "off";
  className?: string;
  children: ReactNode;
};

/** An animated light travelling around its child's border. The child needs an opaque background. */
export const BorderBeam: FC<BorderBeamProps> = ({ state = "rest", className, children }) => (
  <div className={cn("border-beam", className)} data-state={state}>
    {children}
    <span aria-hidden className="border-beam-glow">
      <span className="border-beam-ring" />
    </span>
  </div>
);
